export default "__VITE_ASSET__CMSfHVcc__"